export const appState = $state<{ lastRefreshedAt: Date | null }>({
  lastRefreshedAt: null,
});
